import t from"react";import{mdiLoading as o}from"@mdi/js";import{MdIcon as i}from"./MdIcon.js";const r=({id:r="loading",title:e="Loading",...m})=>t.createElement(i,{id:r,title:e,path:o,...m});export{r as LoadingIcon};
